export default __webpack_public_path__ + "static/media/label_act_pc.fa89ed19.svg";